"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoinbasePaymentType = void 0;
const path = require('path');
const LABEL = 'Coinbase';
class CoinbasePaymentType {
    constructor() {
        this.indexname = 'coinbase';
        this.label = LABEL;
        this.vueJsComponent = 'coinbase-payment-type';
        this.configurationComponentAssets = [
            {
                id: 'coinbase-payment-type_script',
                tag: 'script',
                attributes: {
                    type: 'text/javascript',
                },
                content: path.join(__dirname, '../../dist/coinbase-settings.js'),
            },
            {
                id: 'coinbase-payment-type_style',
                tag: 'style',
                content: path.join(__dirname, '../../dist/css/app.css'),
            },
            {
                id: 'material-icons',
                tag: 'link',
                attributes: {
                    href: 'https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700,900|Material+Icons',
                    rel: 'stylesheet',
                },
            },
        ];
        this.configurationComponentTag = '<coinbase-settings></coinbase-settings>';
    }
    static getLabel() {
        return LABEL;
    }
}
exports.CoinbasePaymentType = CoinbasePaymentType;
//# sourceMappingURL=coinbase-payment-type-config.js.map